/* eslint-disable import/no-unresolved */
import { faFileExport } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconButton, Tooltip } from '@mui/material';
import {
  download,
  generateCsv,
  mkConfig,
  type ConfigOptions,
} from 'export-to-csv';
import React from 'react';

import _ from 'lodash';
import { useTableState } from '../providers/TableStateProvider';

const CSVFileExport = () => {
  const handleExportToCSV = useExportToCSV();

  return (
    <Tooltip title="Export to CSV" enterDelay={600} enterNextDelay={600}>
      <IconButton size="small" onClick={handleExportToCSV}>
        <FontAwesomeIcon icon={faFileExport} />
      </IconButton>
    </Tooltip>
  );
};

export default CSVFileExport;

function useExportToCSV() {
  const tableState = useTableState();

  const columnHeaders = React.useMemo(() => {
    const headers = tableState.table
      .getHeaderGroups()
      .map((header) => header.headers)
      .flat();

    return headers.map((header) => ({
      key: header.id,
      displayLabel: _.isString(header.column.columnDef.header)
        ? header.column.columnDef.header
        : '',
    }));
  }, [tableState.table]);

  return () => {
    const _csvConfig = getCsvConfig({
      columnHeaders,
      filename: tableState.tableId,
      showTitle: true,
    });

    const csv = generateCsv(_csvConfig)(tableState.data?.content ?? []);

    download(_csvConfig)(csv);
  };
}

const getCsvConfig = (options: Partial<ConfigOptions>) =>
  mkConfig({
    fieldSeparator: ',',
    decimalSeparator: '.',
    useKeysAsHeaders: false,
    ...options,
  });
